app.controller('settingsTemplateListController', ['$scope', '$state', 'objectHelper', 'edm.applicationModel', 'mainModel', 'templateModel', 'userModel',
    function ($scope, $state, objectHelper, applicationModel, mainModel, templateModel, userModel) {

        var listeners = {};

        function setData() {
            $scope.columns = [
                {
                    displayName: 'T.DATA.NAME',
                    field: 'name',
                    width: '50%'
                },
                {
                    displayName: 'T.MODULE.TEMPLATES.CREATION_DATE',
                    field: 'creationDate | date:\'yyyy/MM/dd HH:mm\'',
                    width: '40%'
                },
                {
                    cellTemplate: "edm/application/view/app/settings/template/template-actions.html",
                    width: '10%'
                }
            ];
            $scope.criteria = new TemplateDataGridCriteria();

            if(userModel.currentUser) {
                $scope.currentUserId = userModel.currentUser ? userModel.currentUser.id : null;
                $scope.criteria.clinicId = userModel.currentUser.clinicId;
                $scope.criteria.sortColumns = [new EsDataGridSort('name')];
            }

        }

        function setPermissions() {
        }

        function setListeners() {
            listeners.onGetDataPage = function (dataPage) {
                $scope.templates = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            };

            $scope.$on(Event.USER.GET_LOGGED_USER.SUCCESS, function (event, user) {
                $scope.criteria = new TemplateDataGridCriteria();
                $scope.currentUserId = userModel.currentUser.id;
                $scope.criteria.clinicId = userModel.currentUser.clinicId;
                $scope.criteria.sortColumns = [new EsDataGridSort('name')];

                templateModel.getDataPage($scope.criteria).then(function (dataPage) {
                    listeners.onGetDataPage(dataPage);
                });
            });
        }

        function setActions() {
            $scope.onCriteriaChange = function(){
                templateModel.getDataPage($scope.criteria).then(listeners.onGetDataPage);
            };

            $scope.createTemplate = function () {
                  $state.go(Constant.STATE.APP.MEEDY.SETTINGS.TEMPLATE.CREATE);
            };

            $scope.updateTemplate = function (template) {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.TEMPLATE.EDIT, { templateId: template.id });
            };

            $scope.deleteTemplate = function (template) {
                applicationModel.confirm('T.MODULE.TEMPLATES.DO_YOY_REALLY_WANT_TO_DELETE_TEMPLATE').then(function () {
                    templateModel.delete(template).then(function () {
                        $scope.criteria.pageNumber = 0;
                        templateModel.getDataPage($scope.criteria).then(listeners.onGetDataPage);
                    });
                }, function () {
                    // nothing
                });
            };

            $scope.userHasAccessToEntity = function(entity) {
                return entity.user.id === $scope.currentUserId;
            };
        }

        function configureInterface() {

        }

        function initialize() {
            // fixme - getLoogedUser should be called on application bootstrap
            if(!userModel.currentUser) {
                userModel.getLoggedUser();
            } else {
                templateModel.getDataPage($scope.criteria).then(function (dataPage) {
                    listeners.onGetDataPage(dataPage);
                });
            }

            $scope.showAddButton($scope.createTemplate);
            $scope.hideBackButton();
            $scope.resetTitle();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
